module.exports = __webpack_public_path__ + "static/media/aqcquisti_online.13f699c9.png";